import { ReactElement, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector, useSubscription } from '~hooks/index';
import { selectAuth } from '~store/slices/auth/index';
import { isAdminUser } from '~utils/user';
import { openUrlInNewTab } from '~utils/commons';
import { isPlanCorporate } from '~utils/plans';
import { getStringifyUrlQueryString } from '~utils/router';
import { PATHS } from '~constants/paths';
import { SCHEDULE_DEMO_URL } from '~constants/commons';

import { ProToPlusDiscountChipRoot } from './styles';

const ProToPlusDiscountChip = (): ReactElement => {
  const navigate = useNavigate();
  const { user } = useAppSelector(selectAuth);
  const subscription = useSubscription();

  const handleClick = useMemo(() => {
    if (!isAdminUser(user)) return undefined;

    return () => {
      if (isPlanCorporate(subscription)) {
        openUrlInNewTab(SCHEDULE_DEMO_URL);
      } else {
        navigate(
          getStringifyUrlQueryString({
            url: PATHS.CONFIG.SUBSCRIPTIONS.BASE,
            query: {
              currentTab: 'plans-packages',
            },
          }),
        );
      }
    };
  }, [navigate, subscription, user]);

  return (
    <ProToPlusDiscountChipRoot
      label={
        <>
          <b>OFERTA LIMITADA</b> Cambia a plan plus con <b>50% OFF</b>
        </>
      }
      size="small"
      variant="filled"
      onClick={handleClick}
    />
  );
};

export default ProToPlusDiscountChip;
